// Basic
import PropTypes from 'prop-types';
// Components
import FooterClose from '../FooterClose/FooterClose';
import Spinner from '@/common-utils/components/renders/spinner/Spinner';
import { Button } from '../../../../../ui/button';
import { ModalClose, ModalFooter } from '../../../../../ui/modal';
// Common
import ICONS from '../../../../../../enums/icons';

const FooterStep = ({
    step,
    setStep,
    stepsNumber,
    onValidate,
    isLoading,
    disableValidation,
    isError
}) => {
    return (
        <>
            {
                isError ?
                    <FooterClose isLoading={isLoading} />
                    :
                    <ModalFooter>
                        {isLoading && <Spinner className='form-spinner' />}
                        {step === 0 ?
                            <ModalClose asChild>
                                <Button
                                    entity={'button.close'}
                                    variant='secondary'
                                    icon={ICONS.CLOSE}
                                    dataCy='modal-footer-close'
                                />
                            </ModalClose>
                            :
                            <Button
                                entity={'button.previous'}
                                variant='secondary'
                                icon={ICONS.PREVIOUS}
                                onClick={() => setStep(step - 1)}
                                disabled={isLoading}
                                dataCy='modal-footer-previous'
                            />
                        }
                        <Button
                            type='submit'
                            entity={step === stepsNumber - 1 ? 'button.submit' : 'button.next'}
                            variant='primary'
                            icon={ICONS.NEXT}
                            onClick={step === stepsNumber - 1 ? onValidate : () => setStep(step + 1)}
                            disabled={isLoading || disableValidation}
                            dataCy={step === stepsNumber - 1 ? 'modal-footer-submit' : 'modal-footer-next'}
                        />
                    </ModalFooter>
            }
        </>
    );
};

FooterStep.propTypes = {
    step: PropTypes.number.isRequired,
    setStep: PropTypes.func.isRequired,
    stepsNumber: PropTypes.number.isRequired,
    onValidate: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    disableValidation: PropTypes.bool,
    isError: PropTypes.bool
};

export default FooterStep;